import { Component, inject } from '@angular/core';
import { StandPerIntermediateLogyardService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StandPerIntermediateLogyardCreateDto,
  StandPerIntermediateLogyardDto,
  StandPerIntermediateLogyardExcelDownloadDto,
  StandPerIntermediateLogyardUpdateDto,
} from '../proxy/planning/dtos/stand-per-intermediate-logyard';
import { STANDPERINTERMEDIATELOGYARD_CONFIG, STANDPERINTERMEDIATELOGYARD_FIELDS } from './stand-per-intermediate-logyard.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stand-per-intermediate-logyard',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StandPerIntermediateLogyardService, ConfirmationService],
  templateUrl: './stand-per-intermediate-logyard.html',
  styleUrl: './stand-per-intermediate-logyard.scss',
})
export class StandPerIntermediateLogyard extends BaseCrudComponent<
  StandPerIntermediateLogyardDto,
  StandPerIntermediateLogyardCreateDto,
  StandPerIntermediateLogyardUpdateDto,
  StandPerIntermediateLogyardExcelDownloadDto
> {
  service = inject(StandPerIntermediateLogyardService);
  config = STANDPERINTERMEDIATELOGYARD_CONFIG;
  fields = STANDPERINTERMEDIATELOGYARD_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandPerIntermediateLogyardDto): StandPerIntermediateLogyardUpdateDto {
    return {
      logyardLocationId: data.logyardLocationId,
      costReceiverId: data.costReceiverId,
      rowVersion: selected.rowVersion,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StandPerIntermediateLogyard';
  }
}
